import { render, staticRenderFns } from "./HomeCardSkeleton.vue?vue&type=template&id=67adac51"
import script from "./HomeCardSkeleton.vue?vue&type=script&lang=js"
export * from "./HomeCardSkeleton.vue?vue&type=script&lang=js"
import style0 from "./HomeCardSkeleton.vue?vue&type=style&index=0&id=67adac51&prod&lang=postcss"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports